module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$store.state.is_auth && _vm.$route.path.indexOf('/operation/view/') === 0) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "w5-view-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.viewData.title)))]), _vm._v(" "), _vm._l((_vm.Keys), function(row) {
    return (_vm.Keys.length) ? _c('div', {
      key: row,
      staticClass: "w5-form-row"
    }, _vm._l((_vm.sortDATA[row]), function(field, idx) {
      return _c('viewComponent', {
        key: row + '_' + idx,
        attrs: {
          "data": _vm.viewData,
          "rowCount": _vm.sortDATA[row].length,
          "y": row,
          "x": idx,
          "field": field,
          "crud": "operation",
          "realCrudName": "operation",
          "firstElement": _vm.sortDATA && _vm.sortDATA['1'] && _vm.sortDATA['1'][0] ? _vm.sortDATA['1'][0] : null
        }
      })
    }), 1) : _vm._e()
  })], 2) : _c('crudView')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31bbc0c4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/operationView.vue
// module id = 736
// module chunks = 0